<div class="modal-header p-0">

<!--  <h5 class="modal-title" id="exampleModalLabel">Error</h5>-->
  <button
    type="button"
    class="close"
    (click)="onClose()"
  >
    <img src="assets/icons/close.png" alt="close-icon"/>
  </button>
</div>
<div class="modal-body">
  <div class="">
    <div class="d-flex flex-row align-items-start">
      <img src="../assets/img/info-icon.svg" alt="i-icon">
      <div class="ml-2 flex-grow-1">
        <h5 class="modal-title text-danger mb-3">{{config.title}}</h5>

        <p class="mb-4" [innerHTML]="config.text | safeHtml: 'html'">
        </p>
        <div class="d-flex justify-content-between">
          <button class="btn btn-link text-primary p-0" (click)="onReload()">{{config.reload}}</button>
          <button class="btn btn-link text-secondary p-0" (click)="onTryLater()">{{config.tryLater}}</button>
        </div>
      </div>
    </div>
  </div>
</div>

